// ReferEarn.tsx
import "./refer.css";
import React, { useContext, useEffect, useState } from "react";
import QuestContext from "../../../../components/QuestWrapper";
import General, { extractGradientColors, useGeneral } from "../../../../general";
import {
  copyIcon,
  faceBookIcon,
  linkedInIcon,
  tickIcon,
  twitterIcon,
} from "../../../../components/expansion/Svg";
import Label from "../../../../components/Modules/Label";
import { PrimaryButton } from "../../../../components/Modules/PrimaryButton";
import QuestLabs from "../../../../components/QuestLabs";
import ReferEarnApi, { Platform } from "./referEarnApi";
import { ReferEarnProps } from "./referEarnTypes";
import {
  PartialBrandTheme,
  PartialQuestThemeData,
} from "../../tutorial/components/tutorial.types";
import ReferEarnThemeManager from "./referEarnThemeManager";
import { Facebook, LinkedIn, Twitter } from "./SVG";

const ReferIcon = ({ primary, secondary }: any) => {
  return <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M72.4749 29.2978L42.2999 52.2728C40.9499 53.2978 39.0499 53.2978 37.6999 52.2728L7.5249 29.2978C7.7499 28.7728 8.1499 28.2978 8.6499 27.8978L37.7249 5.77282C38.3784 5.27407 39.1778 5.00391 39.9999 5.00391C40.822 5.00391 41.6214 5.27407 42.2749 5.77282L71.3499 27.8978C71.8499 28.2978 72.2499 28.7728 72.4749 29.2978Z" fill={primary || "#9035FF"} />
    <path d="M63.4749 16.4998V68.3498C63.4749 71.0748 61.2499 73.2748 58.5249 73.2748H21.4749C18.7499 73.2748 16.5249 71.0748 16.5249 68.3498V16.4998C16.5249 13.7748 18.7499 11.5498 21.4749 11.5498H58.5249C61.2499 11.5498 63.4749 13.7748 63.4749 16.4998Z" fill="white" />
    <path d="M63.4749 16.4998V20.2498C63.4749 17.5248 61.2499 15.2998 58.5249 15.2998H21.4749C18.7499 15.2998 16.5249 17.5248 16.5249 20.2498V16.4998C16.5249 13.7748 18.7499 11.5498 21.4749 11.5498H58.5249C61.2499 11.5498 63.4749 13.7748 63.4749 16.4998ZM63.4749 68.3498V72.0998C63.4749 74.8248 61.2499 77.0248 58.5249 77.0248H21.4749C18.7499 77.0248 16.5249 74.8248 16.5249 72.0998V68.3498C16.5249 71.0748 18.7499 73.2748 21.4749 73.2748H58.5249C61.2499 73.2748 63.4749 71.0748 63.4749 68.3498Z" fill="#EAEAEA" />
    <path d="M63.4749 31.4248V68.3498C63.4749 71.0748 61.2499 73.2748 58.5249 73.2748H21.4749C18.7499 73.2748 16.5249 71.0748 16.5249 68.3498V31.4248L39.9749 49.2998L63.4749 31.4248Z" fill="#EFEFEF" />
    <path d="M72.8499 30.8998V71.2248C72.8499 73.2998 71.1749 74.9998 69.0749 74.9998H10.9249C8.8249 74.9998 7.1499 73.2998 7.1499 71.2248V30.8998C7.1499 30.3248 7.2749 29.7748 7.5249 29.2998L37.6999 52.2748C39.0499 53.2998 40.9499 53.2998 42.2999 52.2748L65.0499 34.9498L72.4749 29.2998C72.7249 29.7748 72.8499 30.3248 72.8499 30.8998Z" fill={secondary || "#BF8AFF"} />
    <path d="M72.8501 30.8998V71.2248C72.8501 73.2998 71.1751 74.9998 69.0751 74.9998H57.3501C64.8501 59.4748 65.7751 44.9498 65.0501 34.9498L72.4751 29.2998C72.7251 29.7748 72.8501 30.3248 72.8501 30.8998Z" fill={primary || "#8634EA"} />
    <path d="M39.9998 39.9153C44.9123 39.1278 48.6173 36.0953 49.3048 32.3728C50.1923 27.5628 45.6998 21.7103 39.9998 26.4253C34.2998 21.7078 29.8073 27.5628 30.6948 32.3728C31.3823 36.0953 35.0873 39.1278 39.9998 39.9153Z" fill="#FE4F60" />
    <path d="M49.2999 32.3749C48.6249 36.0999 44.8999 39.1249 39.9999 39.9249C38.8999 39.7499 37.8499 39.4499 36.8999 39.0499C41.5249 37.5499 44.9249 34.5499 45.5249 31.1999C45.8499 29.3999 45.2999 27.1999 44.1749 25.8499C43.6749 25.2249 43.1749 24.9249 42.6749 24.9249C42.6499 24.9249 42.5999 24.9249 42.5499 24.9499C46.9749 23.4999 50.0499 28.3249 49.2999 32.3749Z" fill="#E54756" />
    <path d="M35.9 30.3179C36.2446 29.4149 36.1098 28.5249 35.599 28.33C35.0881 28.135 34.3947 28.7091 34.0501 29.612C33.7056 30.515 33.8404 31.4051 34.3512 31.6C34.8621 31.7949 35.5555 31.2209 35.9 30.3179Z" fill="#FF6D7A" />
  </svg>
}

export const ReferEarnWrapper: React.FC<ReferEarnProps> = ({
  questId = "",
  userId = "",
  token = "",
  heading = "Referral link and code",
  description = "Share your unique referral code with friends and receive 10 coins in credits each time a friend signs up!",
  referralLink = "",
  shareButtonText = "Copy Referral Link",
  secondaryIconColor = "#939393",
  gradientBackground = false,
  primaryHeading = "Refer and earn!",
  primaryDescription = "Welcome back, Please complete your details",
  onCopy = (referalCode: string) => {},
  showReferralCode = true,
  gradientBackgroundColor,
  uniqueEmailId,
  uniqueUserId,
  styleConfig,
  footerLink,
  brandTheme,
  variation,
  QuestThemedata,
  showRefferalLogo = true,
  entityAuthenticationToken,
}) => {
  const [shareCode, setCode] = useState("");
  const [copy, setCopy] = useState<boolean[]>([false, false]);
  const { apiKey, entityId, themeConfig, apiType, user } = useContext(
    QuestContext.Context
  );
  const [showFooter,setShowFooter] = useState(true);
  const [questThemeData, setQuestThemeData] = useState<
    PartialQuestThemeData | undefined
  >(QuestThemedata);
  const [BrandTheme, setBrandTheme] = useState<PartialBrandTheme | undefined>(
    brandTheme
  );
  const [headingApi, setHeadingApi] = useState(heading);
  const [descriptionApi, setDescriptionApi] = useState(description);
  const [primaryHeadingApi, setPrimaryHeadingApi] = useState(primaryHeading);
  const [primaryDescriptionApi, setPrimaryDescriptionApi] = useState(primaryDescription);
  const [shareButtonTextApi, setShareButtonTextApi] = useState(shareButtonText);
  const [referralLinkApi, setReferralLinkApi] = useState(referralLink);
  const [secondaryIconColorApi, setSecondaryIconColorApi] = useState(secondaryIconColor);
  const [gradientBackgroundApi, setGradientBackgroundApi] = useState(gradientBackground);
  const [gradientBackgroundColorApi, setGradientBackgroundColorApi] = useState(gradientBackgroundColor);
  const [showReferralCodeApi, setShowReferralCodeApi] = useState(showReferralCode);
  const [showRefferalLogoApi, setShowRefferalLogoApi] = useState(showRefferalLogo);

  const themeManager = React.useMemo(
    () =>
      new ReferEarnThemeManager(
        themeConfig,
        styleConfig,
        questThemeData,
        BrandTheme
      ),
    [themeConfig, styleConfig, questThemeData, brandTheme]
  );

  
  const referEarnApi = new ReferEarnApi(apiType);
  const GeneralFunctions = new General("mixpanel", apiType);
  const general = useGeneral("quest");

  useEffect(() => {
    const initializeReferral = async () => {
      GeneralFunctions.fireTrackingEvent("quest_referral_loaded", "referral");
      general.trackEvent(
        "quest-referral-loaded",
        (uniqueUserId || userId || user.userId)!,
        {},
        true,
        !uniqueUserId,
        true
      );

      if (!entityId || !apiKey || !questId) return;

      try {
        const userAuth = await referEarnApi.getUserAuth({
          apiKey,
          entityId,
          uniqueUserId,
          uniqueEmailId,
          userId,
          token,
          entityAuthenticationToken,
        });

        if (!userAuth) return;

        const headers = {
          apiKey,
          userId: userAuth.userId,
          token: userAuth.token,
        };

        const response = await referEarnApi.getReferralCode(
          questId,
          entityId,
          headers,
          variation
        );
        if (response?.sdkConfig?.uiProps) {
          if (response.sdkConfig.uiProps.questThemeData) {
            setQuestThemeData(response.sdkConfig.uiProps.questThemeData);
          }
          if (response.sdkConfig.uiProps.BrandTheme) {
            setBrandTheme(response.sdkConfig.uiProps.BrandTheme.properties);
          }
          if (response.sdkConfig.uiProps.showFooter !== undefined) {
            setShowFooter(response.sdkConfig.uiProps.showFooter);
          }
          if (response.sdkConfig.uiProps.heading) {
            setHeadingApi(response.sdkConfig.uiProps.heading);
          }
          if (response.sdkConfig.uiProps.description) {
            setDescriptionApi(response.sdkConfig.uiProps.description);
          }
          if (response.sdkConfig.uiProps.referralLink) {
            setReferralLinkApi(response.sdkConfig.uiProps.referralLink);
          }
          if (response.sdkConfig.uiProps.shareButtonText) {
            setShareButtonTextApi(response.sdkConfig.uiProps.shareButtonText);
          }
          if (response.sdkConfig.uiProps.secondaryIconColor) {
            setSecondaryIconColorApi(response.sdkConfig.uiProps.secondaryIconColor);
          }
          if (response.sdkConfig.uiProps.gradientBackground !== undefined) {
            setGradientBackgroundApi(response.sdkConfig.uiProps.gradientBackground);
          }
          if (response.sdkConfig.uiProps.gradientBackgroundColor) {
            setGradientBackgroundColorApi(response.sdkConfig.uiProps.gradientBackgroundColor);
          }
          if (response.sdkConfig.uiProps.showReferralCode !== undefined) {
            setShowReferralCodeApi(response.sdkConfig.uiProps.showReferralCode);
          }
          if (response.sdkConfig.uiProps.showRefferalLogo !== undefined) {
            setShowRefferalLogoApi(response.sdkConfig.uiProps.showRefferalLogo);
          }
          if (response.sdkConfig.uiProps.primaryHeading) {
            setPrimaryHeadingApi(response.sdkConfig.uiProps.primaryHeading);
          }
          if (response.sdkConfig.uiProps.primaryDescription) {
            setPrimaryDescriptionApi(response.sdkConfig.uiProps.primaryDescription);
          }
        }
        setCode(response.referralCode);
      } catch (error) {
        GeneralFunctions.captureSentryException(error);
      }
    };

    initializeReferral();
  }, [entityId, apiKey, questId, uniqueUserId, uniqueEmailId]);

  useEffect(() => {
    if (themeConfig) themeManager.updateThemeConfig(themeConfig);
    if (styleConfig) themeManager.updateStyleConfig(styleConfig);
    if (questThemeData) themeManager.updateQuestTheme(questThemeData);
    if (BrandTheme) themeManager.updateBrandTheme(BrandTheme);
  }, [themeConfig, styleConfig, questThemeData, BrandTheme]);

  const handleCopy = (index: number) => {
    const textToCopy = !index ? shareCode : referralLinkApi + shareCode;
    navigator?.clipboard.writeText(textToCopy);

    setCopy((prev) => prev.map((e, i) => (i === index ? true : e)));
    setTimeout(() => {
      setCopy((prev) => prev.map((e, i) => (i === index ? false : e)));
    }, 3000);

    onCopy(textToCopy);
    GeneralFunctions.fireTrackingEvent(
      `quest_referral_${!index ? "code" : "link"}_copy_clicked`,
      "referral"
    );
    general.trackEvent(
      'quest-referral-copy-btn-click',
      (uniqueUserId || userId || user.userId)!,
      { type: !index ? 'code' : 'link' },
      true,
      !uniqueUserId
    )
  };

  const handleSocialShare = (platform: Platform) => {
    GeneralFunctions.fireTrackingEvent(
      `quest_referral_${platform}_btn_clicked`,
      "referral"
    );
    general.trackEvent(
      'quest-referral-social-btn-click',
      (uniqueUserId || userId || user.userId)!,
      { platform },
      true,
      !uniqueUserId
    )

    referEarnApi.shareOnPlatform(referralLinkApi + shareCode, platform);
  };

  const renderReferralCodeSection = () => (
    <div className="q_refer_code_content">
      <Label children="Referral Code" style={themeManager.getLabelStyles()} />
      <div
        className="q_refer_code_box"
        style={themeManager.getReferralCodeStyles().container}
      >
        <div
          className="q_refer_code"
          style={themeManager.getReferralCodeStyles().text}
        >
          {shareCode}
        </div>
        <img
          className="q_refer_copy_icon"
          src={
            copy[0]
              ? tickIcon(extractGradientColors(styleConfig?.Icon?.color || BrandTheme?.primaryColor || QuestThemedata?.accentColor || "#0065FF"))
              : copyIcon(secondaryIconColorApi)
          }
          onClick={() => handleCopy(0)}
          alt=""
          style={{ ...themeManager.getIconStyles(), background: "none" }}
        />
      </div>
    </div>
  );

  const renderReferralLinkSection = () => (
    <div className="q_refer_code_content">
      <Label children="Invitation Link" style={themeManager.getLabelStyles()} />
      <div
        className="q_refer_code_box"
        style={themeManager.getReferralCodeStyles().container}
      >
        <div
          className="q_refer_code"
          style={themeManager.getReferralCodeStyles().text}
        >
          {referralLinkApi}
          {shareCode}
        </div>
        <img
          className="q_refer_copy_icon"
          src={
            copy[1]
              ? tickIcon(extractGradientColors(styleConfig?.Icon?.color || BrandTheme?.primaryColor || QuestThemedata?.accentColor || "#0065FF"))
              : copyIcon(secondaryIconColorApi)
          }
          onClick={() => handleCopy(1)}
          alt=""
          style={{ ...themeManager.getIconStyles(), background: "none" }}
        />
      </div>
    </div>
  );

  const renderSocialLinks = () => (
    <div className="q_social_links">
      <div
        className="q_social_link_icon"
        style={themeManager.getIconStyles()}
        onClick={() => handleSocialShare("linkedin")}
      >
        <LinkedIn color={extractGradientColors(styleConfig?.Icon?.color || BrandTheme?.primaryColor || QuestThemedata?.accentColor || "#0065FF")} />
      </div>
      <div
        className="q_social_link_icon"
        style={themeManager.getIconStyles()}
        onClick={() => handleSocialShare("facebook")}
      >
        <Facebook color={extractGradientColors(styleConfig?.Icon?.color || BrandTheme?.primaryColor || QuestThemedata?.accentColor || "#0065FF")} />
      </div>
      <div
        className="q_social_link_icon"
        style={themeManager.getIconStyles()}
        onClick={() => handleSocialShare("x")}
      >
        <Twitter color={extractGradientColors(styleConfig?.Icon?.color || BrandTheme?.primaryColor || QuestThemedata?.accentColor || "#0065FF")} />
      </div>
    </div>
  );

  const renderMainContent = () => (
    <div
      className="q_refer_and_earn"
      style={themeManager.getMainContentStyles()}
    >
      {showRefferalLogoApi && (
        <div className="q_refer_head">
          <ReferIcon primary={themeManager.getReferIconColors().primary} secondary={themeManager.getReferIconColors().secondary} />
        </div>
      )}

      <div className="q_refer_content">
        <div className="refer_content_box">
          <div
            className="q_refer_heading"
            style={themeManager.getHeadingStyles()}
          >
            {headingApi}
          </div>
          <div
            className="q_refer_desc"
            style={themeManager.getDescriptionStyles()}
          >
            {descriptionApi}
          </div>
        </div>

        {showReferralCodeApi && renderReferralCodeSection()}
        {referralLinkApi && renderReferralLinkSection()}

        <PrimaryButton
          children={shareButtonTextApi}
          style={themeManager.getPrimaryButtonStyles()}
          onClick={() => {
            handleCopy(1);
            GeneralFunctions.fireTrackingEvent(
              "quest_referral_copy_referral_primary_btn_clicked",
              "referral"
            );
          }}
          type="button"
        />

        {renderSocialLinks()}
      </div>

      {!gradientBackgroundApi && showFooter && (
        <QuestLabs
          style={themeManager.getFooterStyles().container}
          textStyle={themeManager.getFooterStyles().text}
          iconStyle={themeManager.getFooterStyles().icon}
          text={themeManager.getFooterStyles().content.text}
          link={footerLink}
        />
      )}
    </div>
  );

  if (gradientBackgroundApi) {
    return (
      <div style={themeManager.getGradientWrapperStyles()}>
        <div
          className="q_gradient_background"
          style={themeManager.getGradientContainerStyles(
            gradientBackgroundColorApi
          )}
        >
          <div className="q_gradient_head">
            <div
              className="q_gradient_heading"
              style={themeManager.getGradientHeadingStyles()}
            >
              {primaryHeadingApi}
            </div>
            <div
              className="q_gradient_description"
              style={themeManager.getGradientDescriptionStyles()}
            >
              {primaryDescriptionApi}
            </div>
          </div>
          {renderMainContent()}
          <div className="q_gradient_quest_powered">
            {showFooter && (
              <QuestLabs
                style={themeManager.getFooterStyles().container}
                textStyle={themeManager.getFooterStyles().text}
                iconStyle={themeManager.getFooterStyles().icon}
                text={themeManager.getFooterStyles().content.text}
                link={footerLink}
              />
            )}
          </div>
        </div>
      </div>
    );
  }

  return renderMainContent();
};

export default ReferEarnWrapper;
